import React, { useEffect, useContext, useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import styles from "./login.module.css";
import imagen1 from "./assets/nuevo Logo.png";
import imagen4 from "./assets/4LogoPortal.png";
import { useNavigate } from "react-router-dom";
import { postFormData } from "../../services/http";
import LockIcon from "@mui/icons-material/Lock";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { ContextSession } from "../../services/ContextSession";
import WarningIcon from "@mui/icons-material/Warning";
import Lottie from "react-lottie-player";
import passwordAnimation from "./Password.json";
import { useMediaQuery } from "@mui/material";
import mouseRojo from "./assets/Mouse.json";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  InputAdornment,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Alert,
  TextField,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CryptoJS from "crypto-js";

// Función para hacer login
async function doLogin(email, password, ip) {
  const be = "2PQ2WI6oAxDYAaRDegWOsg9smJclabbYi7y3nFivisTBaDlHlE";
  const encryptAES = (data, key) => {
    return CryptoJS.AES.encrypt(data, key).toString();
  };
  const encryptedEmail = encryptAES(email, be);
  const encryptedPassword = encryptAES(password, be);
  let url = `${ip}/api/part/login/`;
  //let url = `http://127.0.0.1:8000/api/part/login/`;
  const data = new FormData();
  data.append("usuario", encryptedEmail);
  data.append("passs", encryptedPassword);
  try {
    return await postFormData(url, data);
  } catch (error) {
    // Maneja el error aquí si es necesario
    return { error: true, message: error.message }; // Devuelve el mensaje de error para ser mostrado en la UI
  }
}

async function restablecerContraseña(dni, correo, ip) {
  let url = `${ip}/api/part/restablecerpass/`;
  const data = new FormData();
  data.append("dni", dni);
  data.append("correo", correo);
  try {
    return await postFormData(url, data);
  } catch (error) {
    // Maneja el error aquí si es necesario
    return { error: true, message: error.message }; // Devuelve el mensaje de error para ser mostrado en la UI
  }
}

// Función para inactivar usuario
async function inactivarUsuario(email, ip) {
  let url = `${ip}/api/part/inactivaruser/`;
  const data = new FormData();
  data.append("usuario", email);
  try {
    await postFormData(url, data);
  } catch (error) {
    console.error("Error al inactivar usuario:", error.message);
  }
}

const SignInSide = () => {
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const toggle = (id) => {
    const container = document.getElementById("container");
    const imglogin = document.getElementById("imglogin");
    const imgsingg = document.getElementById("imgsing");
    const boxsign = document.getElementById("box-sign-up");
    if (container) {
      if (id === 1) {
        imgsingg.classList.add(styles["imgsingup"]);
        imglogin.classList.add(styles["imglogin2"]);
        boxsign.classList.add(styles["box-sign-up"]);
        imglogin.classList.remove(styles["imglogin"]);
        imgsingg.classList.remove(styles["imgsingup2"]);
      } else {
        imgsingg.classList.add(styles["imgsingup2"]);
        imglogin.classList.add(styles["imglogin"]);
        imglogin.classList.remove(styles["imglogin2"]);
        imgsingg.classList.remove(styles["imgsingup"]);
        boxsign.classList.remove(styles["box-sign-up"]);
      }
      container.classList.toggle(styles["sign-in"]);
      container.classList.toggle(styles["sign-up"]);
    }
  };

  let sessi = useContext(ContextSession);
  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [credencialesEmpty, setCredencialesEmpty] = useState(true);
  const [intentos, setIntentos] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState(""); // Mensaje de error
  const isMobile = useMediaQuery("(max-width:900px)"); // Detectar si es una pantalla móvil

  // Variables para el formulario de restablecimiento de contraseña
  const [dniValue, setDniValue] = useState("");

  const handleChange = (event) => {
    const newValue = event.target.value;
    // Filtra los caracteres para permitir solo números
    const numericValue = newValue.replace(/\D/g, "");
    // Limita la longitud a 13 caracteres
    if (numericValue.length <= 13) {
      setDniValue(numericValue);
    }
  };

  const [correoValue, setCorreoValue] = useState("");
  const [errorMsgRestablecer, setErrorMsgRestablecer] = useState(""); // Mensaje de error en restablecimiento
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [loading, setLoading] = useState(false); // Estado para manejar el progreso de la carga
  const [openModal, setOpenModal] = useState(false); // Nuevo estado para el modal

  const navigate = useNavigate();

  const validarEmpty = () => {
    let flag = true;
    if (emailValue.length >= 3 && passwordValue.length >= 3) flag = false;
    setCredencialesEmpty(() => flag);
  };

  const handleEmailChange = (event) => {
    setEmailValue(event.target.value);
    const email = event.target.value;
    setEmailValue(email);
    setEmailValid(email.length >= 3);
    validarEmpty();
  };

  const handlePasswordChange = (event) => {
    setPasswordValue(event.target.value);
    const password = event.target.value;
    setPasswordValue(password);
    setPasswordValid(password.length >= 3);
    validarEmpty();
  };

  const handleShowPassword = () => {
    setShowPassword((showPassword) => !showPassword);
  };

  useEffect(() => {
    let sid = sessi.getVariable("AbrirAgradecimiento");
    const container = document.getElementById("container");
    const container2 = document.getElementById("my-container");
    const container3 = document.getElementById("my-container2");
    const imglogin = document.getElementById("imglogin");
    const imgsingg = document.getElementById("imgsing");
    imgsingg.classList.add(styles["imgsingup2"]);

    if (isMobile) {
      container2.style.zoom = "70%";
      container3.style.zoom = "70%";
    }

    if (container) {
      setTimeout(() => {
        container.classList.add(styles["sign-in"]);
        imglogin.classList.add(styles["imglogin"]);
      }, 200);
    }

    //console.log("EL SID RECIBIDO ES:::::::::::", sid)
    if (sid === true) {
      setOpenModal(true); // Abre el modal si sid es true
      sessi.clearVariables();
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        handleSubmit(); // Ejecuta la función de inicio de sesión al presionar Enter
      }
    };

    // Añadir el listener cuando el componente se monta
    document.addEventListener("keydown", handleKeyDown);

    // Eliminar el listener cuando el componente se desmonta
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [emailValue, passwordValue]); // Asegúrate de que se ejecute cuando los valores de email y password cambien

  const handleSubmit = async () => {
    // Verificar si los campos están vacíos
    if (!emailValue || !passwordValue) {
      setErrorMsg("Por favor, complete todos los campos antes de continuar.");
      return;
    }

    setLoading(true); // Mostrar el CircularProgress
    let datas = await doLogin(emailValue, passwordValue, sessi.ip);
    setLoading(false); // Ocultar el CircularProgress

    if (!datas.error) {
      sessi.sessionStart(datas);
      navigate("/Dashboard");
    } else {
      // Manejo de errores basado en el mensaje de respuesta
      if (datas.message === "La contraseña no es válida.") {
        setErrorMsg(
          `La contraseña no es válida. Intentos fallidos: ${intentos + 1}/3`,
        );
      } else {
        setErrorMsg(
          `Credenciales incorrectas. Intentos fallidos: ${intentos + 1}/3`,
        );
      }
      setIntentos((prevIntentos) => prevIntentos + 1);
      if (intentos + 1 === 3) {
        // Bloquear al usuario
        await inactivarUsuario(emailValue, sessi.ip);
        setOpenDialog(true); // Mostrar diálogo cuando se alcance el límite de intentos
        setSubmitButtonDisabled(true); // Deshabilitar el botón de inicio de sesión
      }
    }
  };

  const handleRestablecerSubmit = async () => {
    if (!dniValue || !correoValue) {
      setErrorMsgRestablecer("Todos los campos deben ser completados.");
      return;
    }
    if (!/^\d{13}$/.test(dniValue)) {
      setErrorMsgRestablecer("El número de identidad debe tener 13 dígitos.");
      return;
    }
    if (!/^[\w-.]+@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(correoValue)) {
      setErrorMsgRestablecer(
        "El formato del correo electrónico es incorrecto.",
      );
      return;
    }

    setErrorMsgRestablecer(""); // Limpiar errores anteriores
    setLoading(true); // Mostrar el CircularProgress

    let response = await restablecerContraseña(dniValue, correoValue, sessi.ip);

    setLoading(false); // Ocultar el CircularProgress

    if (!response.error) {
      setOpenSuccessDialog(true);
    } else {
      setErrorMsgRestablecer(
        response.message ||
          "Error desconocido al intentar restablecer la contraseña.",
      );
    }
  };

  const handleInput = (e) => {
    const valor = e.target.value.replace(/[^0-9]/g, "");
    setDniValue(valor);
  };

  return (
    <div style={{ backgroundColor: "#f0f0f0" }}>
      <div id="container" className={styles.container}>
        <div className={styles.row}>
          <div
            className={`${styles.coll2} ${styles["align-items-center"]}   ${styles["flex-col"]} ${styles["sign-up"]}`}
            id="my-container2"
          >
            <div
              className={`${styles["form-wrapper"]} ${styles["align-items-center"]}`}
            >
              <div
                id="box-sign-up"
                className={`${styles.form} ${styles["sign-up"]}`}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center", // Centra los elementos horizontalmente
                  }}
                >
                  <Lottie
                    loop
                    animationData={mouseRojo}
                    play
                    style={{ width: "10%", height: "auto" }}
                  />
                  <a href="/">
                    <img
                      src={imagen4}
                      alt="imagen3"
                      style={{
                        width: !isMobile ? "220px" : "150px",
                        height: "auto",
                        marginLeft: "10px",
                      }}
                    />
                  </a>
                </div>
                <TextField
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  id="identidad"
                  placeholder="Número de identidad"
                  value={dniValue}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <AccountCircleIcon
                        sx={{ marginRight: "8px", color: "grey" }}
                      />
                    ),
                    inputMode: "numeric", // Esto ayuda en dispositivos móviles
                    type: "tel", // Esto sugiere al navegador que es un campo numérico
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": {
                        borderColor: "#72D2DA",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#72D2DA",
                      },
                    },
                  }}
                />
                <TextField
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  id="correo"
                  placeholder={"Correo Electrónico"}
                  value={correoValue}
                  onChange={(e) => setCorreoValue(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <ContactMailIcon
                        sx={{ marginRight: "8px", color: "grey" }}
                      />
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": {
                        borderColor: "#72D2DA",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#72D2DA",
                      },
                    },
                  }}
                />
                <button
                  style={{ marginTop: 18 }}
                  onClick={handleRestablecerSubmit}
                >
                  Solicitar Cambio
                </button>
                {loading && <CircularProgress sx={{ marginTop: 2 }} />}{" "}
                {/* Muestra el CircularProgress cuando está cargando */}
                {errorMsgRestablecer && (
                  <Alert
                    severity="warning"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                  >
                    {errorMsgRestablecer}
                  </Alert>
                )}
                <p>
                  <b onClick={() => toggle(2)} className={styles.pointer}>
                    Volver a iniciar sesión
                  </b>
                </p>
              </div>
            </div>
          </div>

          <div
            className={`${styles.coll} ${styles["align-items-center"]} ${styles["flex-col"]} ${styles["sign-in"]}`}
            id="my-container"
          >
            <div
              className={`${styles["form-wrapper"]} ${styles["align-items-center"]}`}
            >
              <div className={`${styles.form} ${styles["sign-in"]}`}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center", // Centra los elementos horizontalmente
                  }}
                >
                  <Lottie
                    loop
                    animationData={mouseRojo}
                    play
                    style={{ width: "10%", height: "auto" }}
                  />
                  <a href="/">
                    <img
                      src={imagen4}
                      alt="imagen3"
                      style={{
                        width: !isMobile ? "220px" : "150px",
                        height: "auto",
                        marginLeft: "10px",
                      }}
                    />
                  </a>
                </div>

                <TextField
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  placeholder={"Ingresar Nombre de Usuario"}
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={emailValue}
                  onBlur={validarEmpty}
                  onChange={handleEmailChange}
                  InputProps={{
                    startAdornment: (
                      <AccountCircleIcon
                        sx={{ marginRight: "8px" }}
                        color={emailValue ? "disabled" : "action"}
                      />
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": {
                        borderColor: "#72D2DA",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#72D2DA",
                      },
                    },
                  }}
                />
                <TextField
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  placeholder={"Ingresar Contraseña"}
                  type={showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="current-password"
                  value={passwordValue}
                  onBlur={validarEmpty}
                  onChange={handlePasswordChange}
                  InputProps={{
                    startAdornment: (
                      <LockIcon
                        sx={{ marginRight: "8px" }}
                        color={passwordValue ? "disabled" : "action"}
                      />
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleShowPassword}
                          edge="end"
                          className={styles.iconButtonNoBg}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": {
                        borderColor: "#72D2DA",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#72D2DA",
                      },
                    },
                  }}
                />

                {/* Mensaje de error */}
                {errorMsg && (
                  <Alert
                    severity="warning"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                  >
                    {errorMsg}
                  </Alert>
                )}

                <button
                  disabled={submitButtonDisabled}
                  onClick={handleSubmit}
                  style={{ marginTop: 18 }}
                >
                  {loading ? <CircularProgress size={24} /> : "Iniciar Sesión"}{" "}
                  {/* Muestra el CircularProgress cuando está cargando */}
                </button>
                <p>
                  <b onClick={() => toggle(1)} className={styles.pointer}>
                    ¿Olvidó su contraseña?
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.row} ${styles["content-row"]}`}>
          <div
            className={`${styles.col} ${styles["align-items-center"]} ${styles["flex-col"]}`}
          >
            <div className={styles.img}>
              <img
                id="imglogin"
                src={imagen1}
                alt="welcome"
                className={styles.imglogin2}
              />
            </div>
          </div>

          <div
            className={`${styles.col} ${styles["align-items-center"]} ${styles["flex-col"]}`}
          >
            <div
              className={`${styles.img} ${styles["imgsingup2"]}`}
              id="imgsing"
            >
              <Lottie
                loop
                animationData={passwordAnimation}
                play
                style={{ width: !isMobile ? "50%" : "90%", height: "auto" }} // Ajusta el estilo según tus necesidades
              />
            </div>
            {!isMobile && (
              <div className={`${styles.text} ${styles["sign-up"]}`}>
                <h2 style={{ fontSize: isMobile ? 20 : 35 }}>Reestablecer</h2>
                <h2 style={{ fontSize: isMobile ? 20 : 35 }}>Contraseña</h2>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Diálogo para mostrar advertencia de intentos fallidos */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <WarningIcon color="error" sx={{ fontSize: 40, marginRight: 1 }} />
          {" Intentos fallidos"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ textAlign: "justify" }}
          >
            Ha alcanzado el límite de intentos fallidos. Su usuario fue
            bloqueado debido a nuestras políticas de seguridad. Teléfono de
            contacto de Call Center: +504 2290-1900 Opción #3.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            style={{
              backgroundColor: "#72D2DA",
              borderColor: "#72D2DA",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo para mostrar éxito en el restablecimiento */}
      <Dialog
        open={openSuccessDialog}
        onClose={() => setOpenSuccessDialog(false)}
        aria-labelledby="success-dialog-title"
      >
        <DialogTitle
          id="success-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            color="success"
            sx={{ fontSize: 40, marginRight: 1 }}
          />
          {" Solicitud de Cambio Exitosa"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="success-dialog-description"
            sx={{ textAlign: "justify" }}
          >
            La solicitud de cambio de contraseña se realizó con éxito. Los datos
            han sido enviados al correo electrónico proporcionado.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <Button
            onClick={() => setOpenSuccessDialog(false)}
            variant="contained"
            style={{
              backgroundColor: "#19438C",
              borderColor: "#19438C",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo para mostrar agradecimiento */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-title"
      >
        <DialogTitle
          id="modal-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            color="success"
            sx={{ fontSize: 40, marginRight: 1 }}
          />
          Sesión Finalizada
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="modal-description"
            sx={{ textAlign: "center" }}
          >
            Gracias por utilizar nuestros servicios.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <Button
            onClick={() => setOpenModal(false)}
            variant="contained"
            style={{
              backgroundColor: "#19438C",
              borderColor: "#19438C",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SignInSide;
